export default __webpack_public_path__ + "static/media/sort-vertical-1.05f3b040.svg";